<template>
    <v-menu :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-show="exibirAcoes" color="primary" class="btn-acoes"
                   v-bind="attrs"
                   v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item>
                <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
            </v-list-item>
            <v-list-item
                    v-for="acao in acoesPermitidas"
                    :key="acao.titulo"
                    @click="emitAcao(acao)">
                <v-list-item-title>{{ acao.titulo }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
  import { FormasPagamento } from '../../../plugins/constants'
  import { permiteReenviarBoleto, permiteReenviarContrato, permiteRetentarGeracaoProposta } from '../../../helpers/validacao_acoes_carrinho'

  export default {
    props: {
      idDocumento: {
        type: [String, Number],
        default: null
      },
      statusPedido: {
        type: String,
        required: true
      },
      contrato: {
        type: Object,
        default: () => null
      },
      statusBoleto: {
        type: String,
        default: null
      },
      formaPagamento: {
        type: String,
        required: true
      }
    },
    computed: {
      acoesPermitidas () {
        const acoes = []

        if (permiteRetentarGeracaoProposta(this.idDocumento, this.statusPedido)) {
          acoes.push({ titulo: 'Retentar geração da proposta', nomeFuncao: 'retentarGeracaoProposta' })
        }

        if (permiteReenviarContrato(this.contrato)) {
          acoes.push({ titulo: 'Reenviar o contrato', nomeFuncao: 'reenviarContrato' })
        }

        if (permiteReenviarBoleto(this.statusBoleto, this.formaPagamento)) {
          acoes.push({ titulo: 'Reenviar o boleto', nomeFuncao: 'reenviarBoleto' })
        }

        if (this.formaPagamento === FormasPagamento.Link) {
          acoes.push({ titulo: 'Reenviar o link de pagamento', nomeFuncao: 'reenviaLink' })
        }

        return acoes
      },
      exibirAcoes () {
        return this.acoesPermitidas.length > 0
      }
    },
    methods: {
      emitAcao (acao) {
        // Emite um evento usando o nome da função passado em acao.nomeFuncao
        if (acao.nomeFuncao) {
          this.$emit(acao.nomeFuncao, acao)
        }
      }
    }
  }
</script>

<style scoped>
    .btn-acoes {
        padding: 0;
        width: 50px;
        border-radius: 12px !important;
        min-width: 0 !important;
        padding:0px 10px !important;
    }
    .botoes-acao .v-btn {
        flex: 1;
    }
</style>
